import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-services7',
  templateUrl: './section-services7.component.html',
  styleUrls: ['./section-services7.component.css']
})
export class SectionServices7Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
